import { render } from "./SudanPhoneInput.vue?vue&type=template&id=52c8b53e"
import script from "./SudanPhoneInput.vue?vue&type=script&lang=js"
export * from "./SudanPhoneInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__